import Tracker from "../../../../prop-trackers/tracker.js";
import SinglePropTracker from "../../../../prop-trackers/single-prop-tracker.js";
import Mux from "../../../../prop-tracker-utils/mux.js";

class CurrentSlideMux extends Tracker {
    constructor(evtCtx) {
        super();

        this._evtCtx = evtCtx

        this._slideArrayTracker = new SinglePropTracker();
        this._slideIndexTracker = new SinglePropTracker();
        this._mux = new Mux();

        const needsUpdate = () => this.protected_needsUpdate();
        this._slideArrayTracker.listenNeedsUpdate(needsUpdate);
        this._slideIndexTracker.listenNeedsUpdate(needsUpdate);
        this._mux.listenNeedsUpdate(needsUpdate);
    }

    trackTour(tour, tourEvents) {
        this._slideArrayTracker.track(tour, tourEvents, "slides");
    }

    trackSession(session, sessionEvents) {
        this._slideIndexTracker.track(session, sessionEvents, "slideIndex");
    }

    protected_startUpdate() {
        this._slideArrayTracker.updateIfNeeded(({ prop: { newValue } }) => {
            this._mux.setSource(newValue, newValue ? this._evtCtx.getEvents(newValue) : null);
        });

        this._slideIndexTracker.updateIfNeeded(({ prop: { newExists, newValue } }) => {
            this._mux.setKey(newExists ? String(newValue) : undefined);
        });

        return this._mux.startUpdate();
    }

    protected_finishUpdate() {
        this._mux.finishUpdate();
    }
}

export default CurrentSlideMux;
